export default {
  "content": "<g clip-path=\"url(#clip0_2073_27777)\" fill=\"#3F4450\"><path d=\"M3.05 12.95c-.389-.39-.428-.986-.088-1.326l8.662-8.662c.34-.34.937-.3 1.326.088.389.39.428.986.088 1.326l-8.662 8.662c-.34.34-.937.3-1.326-.088z\"/><path d=\"M11.624 13.038L2.962 4.376c-.34-.34-.3-.937.088-1.326.39-.389.986-.428 1.326-.088l8.662 8.662c.34.34.3.937-.088 1.326-.39.389-.986.428-1.326.088z\"/></g><defs><clipPath id=\"clip0_2073_27777\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "16",
    "height": "16",
    "viewBox": "0 0 16 16",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};